import React from 'react';
import logo from '../../../images/logo/logo.svg';

function Logo() {
  return (
    <img
      src={logo}
      alt='Логотип компании Pascal Vent'
      className='logo'
    />
  );
}

export default Logo;
